import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import { listAdminHouses } from "../../services/ledgerService";
import { useImpersonation } from "../../contexts/ImpersonationContext";
import LogInAsModal from "../../components/LogInAsModal";

const AdminHouses = () => {
    const [houses, setHouses] = useState(null);
    const [error, setError] = useState(null);
    const [loginAsTarget, setLoginAsTarget] = useState(null);
    const { startViewing, startLoginAs } = useImpersonation();
    const navigate = useNavigate();

    useEffect(() => {
        listAdminHouses()
            .then(setHouses)
            .catch((e) => setError(e.message));
    }, []);

    if (error) {
        return <div className="container py-3">Error: {error}</div>;
    }
    if (!houses) {
        return <div className="container py-3">Loading...</div>;
    }

    const handleView = (house) => {
        startViewing(house);
        navigate("/games");
    };

    const handleLoginAs = (house) => {
        setLoginAsTarget(house);
    };

    const handleConfirmLoginAs = async (reason) => {
        await startLoginAs(loginAsTarget.ownerId, reason);
        setLoginAsTarget(null);
        navigate("/games");
    };

    return (
        <div className="container py-3 admin-page">
            <h1>Houses</h1>
            <Table striped hover responsive>
                <thead>
                    <tr>
                        <th>Description</th>
                        <th>Owner</th>
                        <th>Email</th>
                        <th className="text-end">Games</th>
                        <th>Last game</th>
                        <th>Last login</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {houses.map((h) => (
                        <tr key={h.houseId}>
                            <td>{h.houseDescription || <em>(no description)</em>}</td>
                            <td>{h.ownerName || <em>(no owner)</em>}</td>
                            <td>{h.ownerEmail}</td>
                            <td className="text-end">{h.gameCount}</td>
                            <td>{h.lastGameAt || "—"}</td>
                            <td>{h.lastLoginAt || "—"}</td>
                            <td>
                                <ButtonGroup size="sm">
                                    <Button variant="outline-primary" onClick={() => handleView(h)}>
                                        View as
                                    </Button>
                                    <Button
                                        variant="outline-danger"
                                        onClick={() => handleLoginAs(h)}
                                        disabled={!h.ownerId}
                                        title={!h.ownerId ? "House has no owner" : undefined}
                                    >
                                        Log in as
                                    </Button>
                                </ButtonGroup>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
            <LogInAsModal
                show={!!loginAsTarget}
                target={loginAsTarget}
                onCancel={() => setLoginAsTarget(null)}
                onConfirm={handleConfirmLoginAs}
            />
        </div>
    );
};

export default AdminHouses;
